<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    stroke-width="1.5"
    stroke="currentColor"
    :class="customStyle"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
</template>

<script>
export default {
  name: 'MinusCircle',
  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
